'use strict';

module.exports = Array.isArray;
